<template>
  <!--  <eq-input :type="item.attributeName"-->
  <!--            :pleaseEnter="item.value"-->
  <!--            :disable="disabled"-->
  <!--            v-model="item.value"/>-->
  <div class="dp-application-personal-photo-field"
       :class="{error}"
  >
    <vg-field
        v-bind="$attrs"
        v-on="$listeners"
        :vertical="files.length > 0"
        :label="label"
    >
      <vg-image-uploader
          class="maximum"
          :file-list="files"
          multiple :max-count="1"
          :max-size="10 * 1024 * 1024"
          :before-delete="(file,detail)=>delImg(file,detail,value)"
          :after-read="(file)=>personalPhotoOnAfterRead(file)"
          @oversize="onOversize"
      />
      <template #description>
        <div style="padding:10px;margin-top: 40px">
          <span style="font-size: 14px; line-height: 23px; color: red;">
              <van-image width="90" height="90" :src="SamplePhotos"
                         style="float: right"/>
            注：<br/>
            <template v-if="!isTenant">
            1.手机号务必填写准确，否则申请后将无法登录和使用电子出入证<br/>
            2.申请电子出入证人脸照片务必是各申请人的本人照片，否则后期物业将无法验真放行，每张照片大小请控制在10MB<br/>
            3.一次最多可以为10人申请电子出入证
            </template>
            <template v-if="isTenant">
            1.申请电子出入证人脸照片务必是各申请人的本人照片，否则后期物业将无法验真放行<br/>
            2.每张照片大小请控制在10MB
            </template>
          </span>
        </div>
      </template>
    </vg-field>
  </div>
</template>

<script>
import {Image, Dialog, Toast} from "vant";
import samplePhotos from "@/assets/myElectronicPass/samplePhotos.png";
import {client} from "@/libraries/http";
import {compressIdCard} from "@/libraries/image-converter";
import AddPhoto from "@/assets/myElectronicPass/addPhoto.svg";
import VgImageUploader from "@/components/Commons/VgImageUploader.vue";
import VgField from "@/components/Commons/VgField.vue";
import idGenerate from "@/libraries/id-generate";
import {mapState} from "pinia";
import useAuthnStore from "@/store/authn";

const onAfterRead = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', '2');
  formData.append('desciption', '');
  formData.append('systemType', 'SERVER_END');
  console.log(formData, "uploadformData")
  return client.post("/api/h5/file_app/upload", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Disable-Loading': 'Disable'
    }
  }).then(rsp => {
    console.log(rsp)
    return rsp;
  })
};

export default {
  name: "DpApplicationPersonalPhotoField",
  components: {
    VgField,
    VgImageUploader,
    "van-image": Image,
  },
  props: {
    label: String,
    value: null,
    disabled: Boolean,
    error: Boolean,
  },
  data() {
    return {
      SamplePhotos: samplePhotos,
      imgSrc: AddPhoto,
      files: this.value ? [{url: this.value}] : []
    }
  },
  computed: {
    ...mapState(useAuthnStore, ['isTenant'])
  },
  methods: {
    input(value) {
      this.$emit('input', value)
    },
    delImg() {
      return new Promise((resolve, reject) => {
        Dialog.confirm({
          message: '提示：是否确认删除？'
        }).then(() => {
          this.files = []
          // photosOvertimeApplication.splice(detail.index)
          this.input(null)
          this.$toast.success('删除成功')
          resolve()
        }).catch(error => {
          this.$toast.fail('已取消')
          reject(error)
        })
      })
    },
    personalPhotoOnAfterRead(fileWrapper) {
      const imgId = idGenerate()
      compressIdCard(fileWrapper.file)
          .then(blob => {
            let file = fileWrapper.file;
            this.files = [{
              file,
              id: imgId,
              status: 'uploading',
              message: '上传中...',
            }]
            return new window.File([blob], file.name, {type: file.type})
          })
          .then(file => onAfterRead(file))
          .then(res => {
            this.files = [{
              id: imgId,
              url: res.data,
              status: 'done',
              message: '',
            }]
            this.input(res.data);
          })
          .catch(() => {
            this.files = [{
              id: imgId,
              status: 'failed',
              message: '上传失败',
            }]
          });
    },
    onOversize(file) {
      console.log(file);
      Toast('文件大小不能超过 10M');
    }
  }
}
</script>

<style scoped>
.dp-application-personal-photo-field {
  border-radius: 10px;
  border: solid 2px transparent;
}

.dp-application-personal-photo-field >>> .vg-field {
  border: 0;
}

.dp-application-personal-photo-field >>> .vg-field:after {
  display: none;
}

.error {
  background-color: rgba(255, 255, 255, 1);
  border: 2px dashed rgba(255, 0, 0, 1);
}
</style>
